import { FETCH_USERS_LIST,FETCH_DEFAULT_DATA,FETCH_VIEW_REPORT,FETCH_REWARD_REPORT,FAILD_MESSAGE } from "../actions/type";

const initialState = {
    user: [],
    department_group: [],
    pod: [],

    email_groups: [],
    groups: [],
    hiring_profile: [],
    hr_permission: [],
    manager_permission: '',
    manager_user: '',
    permissions: [],

    team: [],
    item_count: '',
    activePage: '',
    off_count: '',
    offset: '',
    MyPerform_answer: [],
    MyPerform_question: [],
    overallScore:'',
    comment_result: [],
    emp_detail: [],
    leave_type_err:'',
    registered_mail:'',
    employee_id:'',
    loading:true,
    country_list:[],
    state_list:[],
//    city_list:[]
}

const manageEmployeeReducer = (state = initialState , action ) => {
    const newState = {...state}
    switch (action.type) {
        case FETCH_DEFAULT_DATA:
            return{
                ...state,
                hiring_profile: [...action.hiring_profile],
                permissions: [...action.permissions],
                department_names: [...action.department_names],
                pod_names: [...action.pod_names],
                crop_names: [...action.crop_names],
                email_names: [...action.email_names],
                troop_names: [...action.troop_names],
//                team: [...action.team],
                employee_id: action.employee_id,
                loading:false
                
            } 
            break;
        case FETCH_USERS_LIST:
            return{
                ...state,
                user:[...action.users],
                department_group: [...action.department_group],
                country_list: [...action.country_list],
                state_list: [...action.state_list],
//                city_list: [...action.city_list],
//                pod: [...action.pod],
//                email_groups: [...action.email_groups],
//                groups: [...action.groups],
//                hiring_profile: [...action.hiring_profile],
                hr_permission: action.hr_permission,
//                manager_permission: action.manager_permission,
//                manager_user: [...action.manager_user],
//                permissions: [...action.permissions],
//                team: [...action.team],
//                employee_id: action.employee_id,
                item_count: action.item_count,
                activePage: action.pageNumber,
                off_count: action.off_count,
                offset: action.offset,
                loading:false
                
            } 
            break;
            case FETCH_VIEW_REPORT:
            return {
                ...state,
                MyPerform_answer: [...action.MyPerform_answer],
                MyPerform_question: [...action.MyPerform_question],
                overallScore: [...action.overallScore],
                comment_result: [...action.comment_result],
                loading:false

            }
            break;
            case FETCH_REWARD_REPORT:
            return {
                ...state,
                emp_name: [action.emp_name],
                emp_id: [action.emp_id],
                muvi_employee_id: [action.muvi_employee_id],
                available_leaves: [action.available_leaves],
                leaves_taken: [...action.leaves_taken],
                loading:false,
                level: [action.level],
                yearly_leave_label_wise: [action.yearly_leave_label_wise],
                quarterly_leave_earned: [action.quarterly_leave_earned],
                carry_forward_leave_earned: [action.carry_forward_leave_earned],
                total_carry_forward_leave: [action.total_carry_forward_leave],
                total_leave_credited: [action.total_leave_credited],
                total_leave_available: [action.total_leave_available],
                lop_cnt: [action.lop_cnt],
                total_reward: [action.total_reward],
                advance_leave: [action.advance_leave],
                current_quarter: [action.current_quarter],
            }
            break;
            case FAILD_MESSAGE:
            return {
                ...state,
                registered_mail: [...action.registered_mail],
                loading:false
            }
        default:
            break;
    }
    return newState;
}

export default manageEmployeeReducer;


// WEBPACK FOOTER //
// ./src/reducers/manageEmployeeReducer.js